import React from 'react';
import { Icon, Card, Grid, Label, Header, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ScrollableGrid } from '../styles/ScrollableGrid';

const ClaimsList = ({ allClaims, asLink, assignButton, onAssign }) => {
  if (allClaims.length === 0) {
    return (
      <Segment basic>
        <Header as="h3" textAlign="center">
          No results
        </Header>
      </Segment>
    );
  }
  const grid = {
    minWidth: '950px',
    idWidth: 2,
    statusWidth: 3,
    paxWidth: 2,
    airlineWidth: 4,
    countryWidth: 2,
    disturbanceWidth: 2
  };
  return (
    <div style={ScrollableGrid}>
      <Grid padded style={{ minWidth: grid.minWidth }}>
        <Grid.Row style={{ minWidth: grid.minWidth }}>
          <Grid.Column width={grid.idWidth}>
            <Card.Meta>Claim Id</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.statusWidth}>
            <Card.Meta>Claim Status</Card.Meta>
          </Grid.Column>
          <Grid.Column />
          <Grid.Column width={grid.paxWidth}>
            <Card.Meta>PAX name</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.airlineWidth}>
            <Card.Meta>Airline</Card.Meta>
          </Grid.Column>
          <Grid.Column width={grid.countryWidth}>
            <Card.Meta>Country</Card.Meta>
          </Grid.Column>
          <Grid.Column textAlign="right" width={grid.disturbanceWidth}>
            <Card.Meta>Type of Disturbance</Card.Meta>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {allClaims.map(claim => (
        <Card
          fluid
          key={claim.id}
          to={`/claim/${claim.id}`}
          as={asLink && Link}
          style={{
            margin: '0',
            transform: 'none',
            zIndex: 'auto',
            minWidth: grid.minWidth
          }}
        >
          <Card.Content>
            <Grid style={{ minWidth: grid.minWidth }}>
              <Grid.Row style={{ minWidth: grid.minWidth }}>
                <Grid.Column width={grid.idWidth}>
                  <Card.Header>
                    {claim.id}
                    {assignButton && (
                      <Label
                        color="green"
                        size="tiny"
                        basic
                        style={{ marginLeft: '10px', cursor: 'pointer' }}
                        onClick={() => onAssign(claim.id)}
                      >
                        assign
                      </Label>
                    )}
                  </Card.Header>
                </Grid.Column>
                <Grid.Column width={grid.statusWidth}>
                  <Card.Meta
                    style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                  >
                    {claim.crmState}
                  </Card.Meta>
                </Grid.Column>
                <Grid.Column style={{ textAlign: 'right' }}>
                  <Card.Meta>
                    {claim.claimsPassengerTicketConnection.edges.length > 1 ? (
                      <Icon name="users" />
                    ) : null}
                  </Card.Meta>
                </Grid.Column>
                <Grid.Column width={grid.paxWidth}>
                  <Card.Meta>
                    {claim.passengerTicket.passengerFirstName}{' '}
                    {claim.passengerTicket.passengerLastName}
                  </Card.Meta>
                </Grid.Column>
                <Grid.Column width={grid.airlineWidth}>
                  <Card.Meta>{claim.airline && claim.airline.name}</Card.Meta>
                </Grid.Column>
                <Grid.Column width={grid.countryWidth}>
                  <Card.Meta>
                    {claim.airline && claim.airline.countryName}
                  </Card.Meta>
                </Grid.Column>
                <Grid.Column textAlign="right" width={grid.disturbanceWidth}>
                  <Card.Meta>{claim.reason}</Card.Meta>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
      ))}
    </div>
  );
};

ClaimsList.propTypes = {
  allClaims: PropTypes.array.isRequired,
  asLink: PropTypes.bool,
  assignButton: PropTypes.bool,
  onAssign: PropTypes.func
};

export default ClaimsList;



// WEBPACK FOOTER //
// ./src/component/ClaimsListPage/ClaimsList.js